export const policyManagmentTypes = {
  HANDLE_POLICYMANAGMENTS_INPUTS: "HANDLE_POLICYMANAGMENTS_INPUTS",
  GET_POLICY: "GET_POLICY",
  SET_NEW_POLICY: "SET_NEW_POLICY",
  CREATE_POLICY: "CREATE_POLICY",
  SET_POLICY_NOTES: "SET_POLICY_NOTES",
  DELETE_POLICYMANAGMENT: "DELETE_POLICYMANAGMENT",
  ADD_MOVEMENT: "ADD_MOVEMENT",
  GET_POLICY_NUMBER: "GET_POLICY_NUMBER",
  ADD_MOVEMENT_TO_POLICY: "ADD_MOVEMENT_TO_POLICY",
  EDIT_MOVEMENT_TO_POLICY: "EDIT_MOVEMENT_TO_POLICY",
  DELETE_MOVEMENT_TO_POLICY: "DELETE_MOVEMENT_TO_POLICY",
  GET_POLICY_ACCOUNTS: "GET_POLICY_ACCOUNTS",
  RESTORE_INITIAL: "RESTORE_INITIAL",
  SEND_POLICY_TO_ORACLE: "SEND_POLICY_TO_ORACLE",
};
